import { useState, useRef, useCallback, useEffect } from "react";
function useToonPlayer({ totalPages, autoPlayAudio = false }) {
  const [currentPage, setCurrentPage] = useState(0);
  const [direction, setDirection] = useState("right");
  const audioRef = useRef(null);
  const isFirst = currentPage === 0;
  const isLast = currentPage === totalPages - 1;
  const goNext = useCallback(() => {
    if (currentPage < totalPages - 1) {
      setDirection("right");
      setCurrentPage((p) => p + 1);
    }
  }, [currentPage, totalPages]);
  const goPrev = useCallback(() => {
    if (currentPage > 0) {
      setDirection("left");
      setCurrentPage((p) => p - 1);
    }
  }, [currentPage]);
  const reset = useCallback(() => {
    setCurrentPage(0);
    setDirection("right");
  }, []);
  const playAudio = useCallback(
    (src) => {
      if (!src || !autoPlayAudio) return;
      const audio = audioRef.current;
      if (audio) {
        audio.src = src;
        audio.play().catch(() => {
        });
      }
    },
    [autoPlayAudio]
  );
  const playSoundEffect = useCallback((src) => {
    const audio = audioRef.current;
    if (audio) {
      audio.src = src;
      audio.play().catch(() => {
      });
    }
  }, []);
  useEffect(() => {
    audioRef.current = new Audio();
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, []);
  return {
    currentPage,
    direction,
    isFirst,
    isLast,
    goNext,
    goPrev,
    reset,
    playAudio,
    playSoundEffect,
    totalPages
  };
}
export {
  useToonPlayer
};
//# sourceMappingURL=useToonPlayer.js.map
